import React, { useEffect, useState } from "react";
import { getAllRequisitos } from "../services/requisitos.service";
import {
  Box,
  Grid,
  FormControl,
  TextField,
  Autocomplete,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import ButtonComponent from "./ButtonComponent";
import { COLORS } from "../config/theme";
import { addExpedienteRequisito } from "../services/expediente.service";

export default function AgregarRequisitoManual({
  setIsVisibleModal,
  oficinasList,
  id_expediente,
  setReload,
  reload,
}) {
  const [requisitosList, setRequisitosList] = useState([]);
  const [selectedRequisito, setSelectedRequisito] = useState(null);
  const [selectedOficina, setSelectedOficina] = useState(null);
  const [isObligatorio, setIsObligatorio] = useState("no");

  const getRequester = async () => {
    try {
      const response = await getAllRequisitos();

      if (response.data.length > 0) {
        setRequisitosList(response.data);
      }
    } catch (error) {
      console.log("Failed to get Requester", error);
    }
  };
  useEffect(() => {
    getRequester();
  }, []);

  const onClose = () => {
    setIsVisibleModal(false);
    setSelectedRequisito(null);
    setSelectedOficina(null);
    setIsObligatorio("no");
  };

  const onAdd = async () => {
    const data = {
      id_expediente: Number(id_expediente),
      id_requisito: selectedRequisito.id,
      id_oficina: selectedRequisito.id_oficina,
      opcional: isObligatorio === "yes" ? "1" : "0",
    };

    try {
      const result = await addExpedienteRequisito(data);

      console.log("reusltado al crear requisito:", result);

      if (result.data) {
        setReload(!reload);
        setSelectedRequisito(null);
        setSelectedOficina(null);
        setIsVisibleModal(false);
        setIsObligatorio("no");
      }
    } catch (error) {
      console.log("error create request exp", error);
    }
  };

  return (
    <>
      <Box p={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Autocomplete
                size="small"
                options={requisitosList}
                getOptionLabel={(option) => option.nombre}
                value={selectedRequisito}
                onChange={(e, value) => setSelectedRequisito(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Seleccione un requisito"
                    variant="outlined"
                  />
                )}
              />
            </FormControl>
          </Grid>
          {/* <Grid item xs={12}>
            <FormControl fullWidth>
              <Autocomplete
                size="small"
                options={oficinasList}
                getOptionLabel={(option) => option.nombre}
                value={selectedOficina}
                onChange={(e, value) => setSelectedOficina(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Seleccione una oficina"
                    variant="outlined"
                  />
                )}
              />
            </FormControl>
          </Grid> */}

          <Grid item xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend">¿Requisito obligatorio?</FormLabel>
              <RadioGroup
                row
                value={isObligatorio}
                onChange={(e) => setIsObligatorio(e.target.value)}
              >
                <FormControlLabel
                  value="yes"
                  control={<Radio color="primary" />}
                  label="Sí"
                />
                <FormControlLabel
                  value="no"
                  control={<Radio color="primary" />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between">
              <ButtonComponent
                name="Agregar"
                toAction={() => onAdd(selectedRequisito)}
                disabled={!selectedRequisito}
              />
              <div style={{ width: "5px" }}></div>
              <ButtonComponent
                name="Cancelar"
                toAction={onClose}
                color={COLORS.DANGER}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
